import { QuestReportType } from '@/core/domain/questReport/Reports/WorkOrder/WorkOrder.types';
import { isAppPortocar } from '@/index';
import { Checkbox, Col, Form, Row } from 'antd';
import { useIntl } from 'react-intl';

export default function ReportWorkOrderOtherFields() {
  const intl = useIntl();

  return (
    <Row gutter={[24, 24]}>
      <Col>
        <Form.Item
          noStyle
          name="includeParts"
          initialValue={true}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.checkbox.parts',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          noStyle
          name="includePartsProvided"
          initialValue={false}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.checkbox.partsProvided',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          noStyle
          name="includeServices"
          initialValue={true}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.checkbox.tasks',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          noStyle
          name="includeServicesProvided"
          initialValue={true}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.checkbox.third',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue, setFieldValue }) => {
          const reportType = getFieldValue('reportType');

          return (
            <>
              {isAppPortocar && (
                <Col>
                  <Form.Item
                    noStyle
                    name="IncludeBenefits"
                    initialValue={true}
                    valuePropName="checked"
                  >
                    <Checkbox
                      onChange={({ target: { checked } }) =>
                        checked && setFieldValue('onlyBattery', !checked)
                      }
                    >
                      {intl.formatMessage({
                        id: 'movementWorkOrdersReport.form.checkbox.benefits',
                      })}
                    </Checkbox>
                  </Form.Item>
                </Col>
              )}

              {reportType === QuestReportType.servicesAndPartsPerVehicle &&
                isAppPortocar && (
                  <Col>
                    <Form.Item
                      noStyle
                      name="onlyBattery"
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={({ target: { checked } }) =>
                          checked && setFieldValue('IncludeBenefits', !checked)
                        }
                      >
                        Bateria 7051
                      </Checkbox>
                    </Form.Item>
                  </Col>
                )}

              {reportType === QuestReportType.servicesAndPartsPerVehicle &&
                isAppPortocar && (
                  <Col>
                    <Form.Item
                      noStyle
                      name="onlyPartnerDiscount"
                      valuePropName="checked"
                    >
                      <Checkbox>Apólice</Checkbox>
                    </Form.Item>
                  </Col>
                )}
            </>
          );
        }}
      </Form.Item>
    </Row>
  );
}
